// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"0cbb8146","509":"f6226adf","541":"cecea073","727":"4171e53e","839":"0ec00616"}[chunkId] + ".chunk.js";
};